/**
* ProductCard — grid item for /store pillar and category pages.
*
* No retail price and no star rating: quotes are given per case and we do
* not publish review scores we cannot verify on-page.
*/
import { Link } from "@tanstack/react-router";
import type { Product } from "@/data/products";
import { quoteHint, quoteLabel } from "@/config/pricing";

export function ProductCard({ product }: { product: Product }) {
  return (
    <Link
      to="/store/$product"
      params={{ product: product.slug }}
      className="group flex h-full flex-col rounded-xl border border-border bg-card p-4 shadow-sm transition hover:shadow-md hover:border-primary/50"
    >
      <div className="text-xs font-medium uppercase tracking-wide text-primary">
        NAATI Certified
      </div>
      <h3 className="mt-1 line-clamp-2 text-base font-bold text-foreground group-hover:text-primary">
        {product.doc.nameTh}
      </h3>
      <div className="mt-0.5 text-xs text-muted-foreground">{product.doc.nameEn}</div>
      <div className="mt-3 text-base font-extrabold text-foreground">
        {quoteLabel("th")}
      </div>
      <div className="mt-1 text-xs text-muted-foreground">
        {quoteHint("th")} · 5-7 วันทำการ
      </div>
      <div className="mt-3 flex flex-wrap gap-1">
        {product.doc.keyFields.slice(0, 3).map((f) => (
          <span
            key={f}
            className="rounded-full bg-muted px-2 py-0.5 text-[10px] text-muted-foreground"
          >
            {f}
          </span>
        ))}
      </div>
    </Link>
  );
}
